module.exports = __webpack_public_path__ + "img/photo_size_select_actual.287af8ef.svg";